<template>
  <b-button
    class="tenacy-button-nav"
    :class="{
      tenacy_button_nav_disabled: disabled_condition,
      warning_outline: variant === 'warning' && !disabled_condition,
    }"
    :disabled="disabled_condition"
    :style="{ height: in_array ? '30px' : '40px', 'font-weight': in_array ? '700' : '500' }"
    :variant="variant"
    @click="emitClick"
  >
    <span class="tenacy-btn-label">
      <slot />
    </span>
    <i
      v-b-tooltip
      class="tenacy-btn-icon"
      :class="fa_type + ' fa-' + custom_icon + ' fa-fw'"
      :title="tooltip"
    />
  </b-button>
</template>

<script>
export default {
  name: 'AppButtonNav',

  props: {
    custom_icon: {
      type: String,
      default: 'arrow-right',
    },
    fa_type: {
      type: String,
      default: 'far',
    },
    variant: {
      type: String,
      default: 'outline-primary',
    },
    tooltip: String,
    disabled_condition: {
      type: Boolean,
      default: false,
    },
    in_array: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },
  methods: {
    emitClick(ev) {
      if (!this.disabled) {
        this.$emit('click', ev)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.tenacy-btn-icon {
  margin-left: 4px;
}
.tenacy-button-nav {
  vertical-align: middle;
}

.tenacy_button_nav_disabled,
.tenacy_button_nav_disabled:hover {
  background-color: #dfdfdf !important;
  color: #a6a6a6 !important;
  border: #dfdfdf !important;
}
.warning_outline {
  color: white !important;
  border: white !important;
}
</style>
